(function () {
    'use strict';

    /**
     * News section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_News.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "newsSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionNews', sectionNews);

    function sectionNews() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionNewsCtrl,
            controllerAs: 'newsSection'
        };
    }

    SectionNewsCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionNewsCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the news of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise<boolean>} true when data was received
         */
        function load(eventId, lang) {
            return ApiFactory.GetEventNewsApi(eventId, lang).then(function (response) {
                if (response.data == null)
                    return false;

                vm.items = response.data;
                return true;
            });
        }
    }
})();
